import { brandDocument } from 'configureBrand'
import { assetsUrl } from 'helpers'

const documents = Object.freeze({
  closeAccount: `${assetsUrl}${brandDocument.closeAccountForm}`,
  websiteUsage: `${assetsUrl}${brandDocument.websiteUsage}`,
  privacyPolicy: `${assetsUrl}${brandDocument.privacyPolicy}`,
  questionnaire: `${assetsUrl}/commercial/Questionnaire.pdf`,
  accessibility: 'https://www.synchrony.com/gwas',
  w9ForOtherStates: `${assetsUrl}/commercial/w9_for_other_states.pdf`,
  w9ForStates: `${assetsUrl}/commercial/w9_for_states.pdf`,
  w9Instructions: `${assetsUrl}/commercial/w9_instructions.pdf`
})

export default documents
